import {
  RETENTION_TYPES,
  TASK_STATUS_DONE
} from '@/modules/settings/enum/DataRetentionEnums'

const NEXT_RUN_FIELDS = Object.freeze({
  [RETENTION_TYPES.USER_PROFILES]: 'users_cleanup_next_run',
  [RETENTION_TYPES.PROFILE_AUDIT_LOGS]: 'audit_log_cleanup_next_run',
  [RETENTION_TYPES.CAMPAIGN_AUDIT_LOGS]: 'campaign_audit_log_cleanup_next_run'
})

export default {
  methods: {
    countActivePolicies(retentionType, policy) {
      if (!policy) {
        return 0
      }

      if (retentionType === RETENTION_TYPES.USER_PROFILES) {
        if (!policy.profile_retention) {
          return 0
        }

        return [
          policy.uncontactable_web_devices_retention_period,
          policy.uncontactable_anonymous_profiles_retention_period,
          policy.uncontactable_identified_profiles_retention_period
        ].filter(value => value != null && value !== '' && Number(value) > 0)
          .length
      }

      if (retentionType === RETENTION_TYPES.PROFILE_AUDIT_LOGS) {
        return policy.audit_log_retention &&
          Number(policy.profile_auditlog_retention_period_months) > 0
          ? 1
          : 0
      }

      if (retentionType === RETENTION_TYPES.CAMPAIGN_AUDIT_LOGS) {
        return policy.audit_log_retention &&
          Number(policy.campaign_auditlog_retention_period_months) > 0
          ? 1
          : 0
      }

      return 0
    },

    getNextRunTimestamp(retentionType, policy) {
      if (!policy) {
        return null
      }

      const field = NEXT_RUN_FIELDS[retentionType]
      if (!field) {
        return null
      }

      const value = policy[field]
      return typeof value === 'number' && value > 0 ? value : null
    },

    getExecutionStatus(record) {
      if (!record || typeof record.status !== 'number') {
        return null
      }

      return record.status === TASK_STATUS_DONE ? 'success' : 'failed'
    },

    computeRetentionTotal(record, breakdown = {}) {
      if (!record) {
        return 0
      }
      if (typeof record.total_deleted === 'number') {
        return record.total_deleted
      }
      const result = record.result || {}
      if (typeof result.total_deleted === 'number') {
        return result.total_deleted
      }
      return Object.values(breakdown).reduce(
        (sum, value) => sum + (Number(value) || 0),
        0
      )
    },

    hasHighDeletionWarning(record) {
      if (!record) {
        return false
      }
      if (record.high_deletion_warning) {
        return true
      }
      const result = record.result || {}
      return Boolean(result.high_deletion_warning)
    },

    getHighDeletionImpactPercent(record) {
      const result = (record && record.result) || {}
      const ratios = result.high_deletion_ratios
      if (!ratios || typeof ratios !== 'object') {
        return null
      }

      const values = Object.values(ratios).filter(
        value => typeof value === 'number' && !Number.isNaN(value)
      )
      if (!values.length) {
        return null
      }

      return Math.round(Math.max(...values) * 100)
    },

    normalizeRetentionBreakdown(retentionType, result = {}) {
      if (
        result.breakdown &&
        typeof result.breakdown === 'object' &&
        Object.keys(result.breakdown).length > 0
      ) {
        return result.breakdown
      }

      if (retentionType !== RETENTION_TYPES.USER_PROFILES || !result.stats) {
        return {}
      }

      const stats = result.stats

      return {
        anonymous_profiles: Number(stats.uncontactable_anonymous_profiles) || 0,
        uncontactable_identified_profiles:
          Number(stats.uncontactable_identified_profiles) || 0,
        web_devices:
          (Number(stats.uncontactable_web_devices) || 0) +
          (Number(stats.contactable_web_devices) || 0),
        mobile_devices_ios:
          (Number(stats.uncontactable_mobile_devices_ios) || 0) +
          (Number(stats.contactable_mobile_devices_ios) || 0),
        mobile_devices_android:
          (Number(stats.uncontactable_mobile_devices_android) || 0) +
          (Number(stats.contactable_mobile_devices_android) || 0)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/mixins/dataRetentionMixin.js